import voyageOptionsToJson from "../voyage_options/db/mapper_to_json";

/*
export default function createVoyageDataToJson(createVoyageData) {
    return {
        "route_id": createVoyageData.routeId,
        "route_theyr_id": createVoyageData.routeTheyrId,
        "vessel_id": createVoyageData.vesselId,
        "vessel_theyr_id": createVoyageData.vesselTheyrId,
        "company_id": parseInt(createVoyageData.companyId),
        "description": createVoyageData.description,
        "start_time": createVoyageData.startTime,
        "voyage_options": voyageOptionsToJson(createVoyageData.options)
    }
}
*/

export default function createVoyageDataToJson(createVoyageData) {
    var startTimeWithSeconds =
        createVoyageData.startTime &&
            createVoyageData.startTime.length === 16
            ? createVoyageData.startTime + ":00"
            : createVoyageData.startTime;


    return {
        route_id: createVoyageData.routeId,
        route_theyr_id: createVoyageData.routeTheyrId,
        vessel_id: createVoyageData.vesselId,
        vessel_theyr_id: createVoyageData.vesselTheyrId,
        company_id: Number(createVoyageData.companyId),
        description: createVoyageData.description,
        start_time: startTimeWithSeconds,
        voyage_options: voyageOptionsToJson(createVoyageData.options)
    }
}
